/* global Element */

import PropTypes from 'prop-types'
import React, { useCallback } from 'react'
import clsx from 'clsx'

import { makeStyles } from '@material-ui/core/styles'

import { useMediaDurationLoader } from './hooks'

const styles = {
  audio: { display: 'none' },
}
const useStyles = makeStyles(styles)

export default function AudioMedia(props) {
  const {
    className,
    media,
    mediaElementRef,
    onDurationChange,
    onPositionChange,
    ...otherProps
  } = props

  useMediaDurationLoader(media, 'audio', onDurationChange)

  const handleDurationChange = useCallback(
    (event) => {
      onDurationChange(event.currentTarget.duration)
    },
    [onDurationChange],
  )

  const handlePositionChange = useCallback(
    (event) => {
      onPositionChange(event.currentTarget.currentTime)
    },
    [onPositionChange],
  )

  const classes = useStyles()

  /* eslint-disable react/jsx-props-no-spreading */
  return (
    <audio
      ref={mediaElementRef}
      className={clsx(classes.audio, className)}
      controls={false}
      onDurationChange={handleDurationChange}
      onTimeUpdate={handlePositionChange}
      preload="metadata"
      src={media}
      {...otherProps}
    />
  )
  /* eslint-enable react/jsx-props-no-spreading */
}

AudioMedia.propTypes = {
  className: PropTypes.string,
  media: PropTypes.string,
  mediaElementRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
  onDurationChange: PropTypes.func,
  onPositionChange: PropTypes.func,
}
